<div class="container-fluid" style="padding-bottom: 30px" [ngClass]="{ 'wait-cursor': grundDaten.waitCursor() }">
  <app-navbar></app-navbar>

  <div class="m-2"><router-outlet></router-outlet></div>
  <ui-scroll-to-top></ui-scroll-to-top>
</div>
<app-footer></app-footer>
@if (grundDaten.waitCursor()) {
  <div class="wait-overlay">
    <div class="wait-box">
      <!--    Bitte warten … -->
      <ui-spinner></ui-spinner>
    </div>
  </div>
}
